import { Radio, X } from 'lucide-react';
import { useEffect, useState } from 'react';

type SoundZoneBadgeProps = {
  zoneName: string;
  onDismiss: () => void;
  autoHide?: boolean;
  duration?: number;
};

export function SoundZoneBadge({
  zoneName,
  onDismiss,
  autoHide = true,
  duration = 3000
}: SoundZoneBadgeProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);

    if (autoHide) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(onDismiss, 300);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [autoHide, duration, onDismiss]);

  return (
    <div
      className={`fixed top-20 left-1/2 transform -translate-x-1/2 z-50 transition-all duration-300 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
      }`}
    >
      <div className="bg-white rounded-full shadow-lg px-6 py-3 flex items-center gap-3 border-2 border-[#00c7b7]">
        <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center">
          <Radio className="w-5 h-5 text-white" />
        </div>
        <div className="pr-2">
          <p className="text-xs text-gray-500 font-medium">Entering Sound Zone</p>
          <p className="text-sm font-bold text-gray-900">{zoneName}</p>
        </div>
        <button
          onClick={() => {
            setIsVisible(false);
            setTimeout(onDismiss, 300);
          }}
          className="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
